import React from 'react';
import {useDrag, useDrop} from 'react-dnd';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsAlt} from '@fortawesome/free-solid-svg-icons';
import styles from './Draggable.module.scss';
import PropTypes from "prop-types";
import {withTranslation} from "react-i18next";

const ACCEPT = 'DRAGGABLE';

const Draggable = ({children, index, moveCard, active, t}) => {
    if (!active) {
        return children;
    }

    const [, drop] = useDrop({
        accept: ACCEPT,
        hover(item, monitor) {
            if (index === item.index) return;
            moveCard(index, item.index);
            item.index = index;
        },
    });

    const [{isDragging}, drag, preview] = useDrag({
        item: {type: ACCEPT, index},
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const containerClasses = [styles.container];
    if (isDragging) containerClasses.push(styles.isDragging);

    return (
        <div ref={drop} className={containerClasses.join(' ')}>
            <div ref={preview}>
                {children}
                <div ref={drag} title={t('Move course')} className={styles.draggableIcon}>
                    <FontAwesomeIcon icon={faArrowsAlt}/>
                </div>
            </div>
        </div>
    )
};

Draggable.propTypes = {
    t: PropTypes.func,
};

Draggable.defaultProps = {
    t: s => s,
};

export default withTranslation()(Draggable);
